import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';
import { clickUpdator } from '../../common/api';
import { nativeShareText } from '../../util/gameUtils';

export default class Score {
  constructor() {
    document
      .querySelector('#score_sec #replayBtn')
      .addEventListener('click', this.replayGame.bind(this));
    document
      .querySelector('#score_sec #leaderBtn')
      .addEventListener('click', this.showLeader.bind(this));
    document
      .querySelector('#score_sec #shareBtn')
      .addEventListener('click', this.shareGame.bind(this));
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    this.prizeShown = false;
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Score') return false;

    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_menu',
        data: {},
      },
    });
    this.events.dispatchEvent({
      type: 'SOUND_EVENTS',
      message: {
        event_type: 'stop_sound',
        data: {
          sndKey: 'crowd',
        },
      },
    });
    this.events.dispatchEvent({
      type: 'SOUND_EVENTS',
      message: {
        event_type: 'play_sound',
        data: {
          sndKey: 'music',
        },
      },
    });
    document.querySelector('.score_tag .score').innerHTML = Global.totalGoals;
    if (data['result']) {
      const result = data['result'];
      document.querySelector(
        '.current_score'
      ).innerHTML = `Current Score: ${result.currentScore}`;
      if (result.currentScore >= result.highScore) {
        document.querySelector('.score_tag img').src = './ui/NewScore.png';
        document.querySelector('.score_tag .score').innerHTML = '';
      } else {
        document.querySelector('.score_tag img').src = './ui/BestScore.png';
        document.querySelector('.score_tag .score').innerHTML =
          result.highScore;
      }
    }

    if (Global.limitReached) {
      document.querySelector('#score_sec #replayBtn').style.display = 'none';
    } else {
      document.querySelector('#score_sec #replayBtn').style.display = 'block';
    }

    document.querySelector('#score_sec .info').innerHTML =
      'Play More & Win More.';
    switch (Global.totalGoals) {
      case 1:
      case 0:
        document.querySelector('#score_sec .info').innerHTML =
          "But keep playing, You'll get there.";
        document.querySelector('#score_sec .title2').innerHTML =
          'Better luck<br/>next time!';
        break;
      case 2:
        document.querySelector('#score_sec .title2').innerHTML =
          'Fantastic Effort!';
        break;
      case 3:
        document.querySelector('#score_sec .title2').innerHTML =
          'You are on Fire!';
        break;
      case 4:
        document.querySelector('#score_sec .title2').innerHTML =
          'You are a Pro!';
        break;
      case 5:
        document.querySelector('#score_sec .title2').innerHTML =
          'Penalty Kick Master!';
        break;
    }
    if (Global.totalGoals <= 1) {
      document
        .querySelector('#score_sec .game_result')
        .classList.remove('active');
      document.querySelector('#score_sec .info').classList.remove('active');
    } else {
      document.querySelector('#score_sec .game_result').classList.add('active');
      document.querySelector('#score_sec .info').classList.add('active');
    }
    document.querySelector('#game_header').classList.remove('active');
    document.querySelector('#score_sec').classList.add('active');
    document.querySelector(
      '#score_sec .game_result .label'
    ).innerHTML = `${Global.totalGoals} Goals`;
  }
  async showLeader() {
    document.querySelector('#loader').classList.add('active');
    // const result = await clickUpdator(true, "leaderboard");
    document.querySelector('#loader').classList.remove('active');
    this.hideScreen();
    Global.goBackTo = 'Score';
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey: 'Leaderboard',
        },
      },
    });
  }
  async replayGame() {
    document.querySelector('#loader').classList.add('active');
    // const result = await clickUpdator(true, "replay");
    // console.log(result);
    // localStorage.setItem('gameKey', result.gameKey);
    document.querySelector('#loader').classList.remove('active');
    this.hideScreen();

    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'replay_game',
        data: {},
      },
    });
  }
  async shareGame() {
    document.querySelector('#loader').classList.add('active');
    // const result = await clickUpdator(true, "shareScore");

    // await nativeShareText(
    //   `Just crushed it on the Heineken Football Game ⚽. Think you can beat my score? Play the Game \n ${window.location}`
    // );
    document.querySelector('#loader').classList.remove('active');
    // navigator.share({
    //   title: "",
    //   text: "I just played Heineken Football Game, Can you score more than me",
    //   url: window.location,
    // });
  }
  showNextScreen() {}
  hideScreen() {
    document.querySelector('#score_sec').classList.remove('active');
  }
}
